export default "__VITE_ASSET__VgCuTfxAtvhNQdygQR4wMQ__"